import { shadows } from "config/styles/shadows";
import { fontSize } from "config/styles/fonts";

const styles = {
  contentWrap: {
    display: "flex",
    flexDirection: "column",
    gap: "30px",
    p: "20px 0",
  },
  infoWrap: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    p: "20px",
    borderRadius: "10px",
    boxShadow: {
      xs: shadows.main,
    },
  },
  title: {
    fontSize: "20px",
  },
  btn: {
    width: "180px",
    height: "40px",
    borderRadius: "6px",
    color: "text.primary",
    alignSelf: "flex-end",
    textTransform: "none",
    fontSize: fontSize.m,
  },
  code: {
    "& .MuiInputBase-root": {
      width: "150px",
    },
  },
  codeText: {
    color: "text.secondary",
    fontSize: fontSize.s,
    mt: "-10px",
  },
  srcAddressWrap: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    position: "relative",
    pt: "10px",
    "& .MuiButtonBase-root": {
      display: "none",
    },
  },
  progress: {
    position: "absolute",
    right: "10px",
    top: "17px",
    color: "text.secondary",
  },
};

export default styles;
